export const SPR_PACKAGE_COUNT_KEY = "sprPackageCount";
export const SPR_TIME_LIMIT_KEY = "sprTimeLimit";
export const ROUTE_DATA_CACHE_KEY = "routeDataCache";
export const PICK_STATUS_IN_GRID_CACHE_KEY = "pickStatusInGridDataCache";
export const PICK_FILTER_STATE_KEY = "pickFilterState";
const SELECTED_PICK_COLUMNS_KEY = "selectedPickColumns";
const SELECTED_PICK_COLUMNS_KEY_VERSION = "v1"; //Increment version if existing column is modified.

export function getPickColumnsKey(capability) {
    return `${SELECTED_PICK_COLUMNS_KEY}_${capability}_${SELECTED_PICK_COLUMNS_KEY_VERSION}`;
}



// WEBPACK FOOTER //
// ./src/components/util/LocalStorageKeys.js